import { InstructionTypes } from '../../Constants'
import { Instruction } from './Instruction'

export class FillInputByNameInstruction extends Instruction {
  constructor ({ name, inputName, waitForNoLoaders, value, scope }) {
    super({ name, waitForNoLoaders, type: InstructionTypes.FillInputByName, scope })
    this.inputName = inputName
    this.value = value
  }

  prepareInstruction (id, params) {
    this.id = id
    this.setValue(params)
  }

  setValue (params) {
    if (this.value === undefined) {
      this.setDefaultValue(params)
    }
  }

  setDefaultValue (params) {
    throw new Error('Method not implemented.')
  }

  getParsedInstruction () {
    const parsedInstruction = {
      ...super.getParsedInstruction(),
      inputName: this.inputName,
      value: this.value
    }
    return parsedInstruction
  }
}
